<template>
  <autocomplete-single name="Специальность" :items="items" :select.sync="localSelect" :loading="loadState.isLoading">
    <template v-slot:itemIcon="{item}">
      <v-avatar :color="item.color" size="10" class="mr-1" style="margin-top:-3px"/>
    </template>
    <template v-slot:selectedInfo="{item}">
      <v-avatar :color="item.color" size="10" class="mr-1" style="margin-top:-2px"/> {{item.name}}
    </template>
  </autocomplete-single>
</template>

<script>
import State from "@/plugins/state";
import AutocompleteSingle from "@/componentsV2/base/AutocompleteSingle.vue";
import {
  Entity_Spec,
} from "../../../EntityStoreCacheService";


export default {
  components: {AutocompleteSingle},
  props:[
    'select',
  ],
  data:()=>({
    loadState: new State(),
    items: [],
    localSelect: null
  }),
  watch: {
    select() {
      this.localSelect = this.select;
    },
    localSelect() {
      this.$emit('update:select', this.localSelect)
    }
  },
  mounted() {
    this.localSelect = this.select;
    this.load();
  },
  methods:{
    load(){
      if (this.items.length===0) {
        new Entity_Spec()
          .selects(Entity_Spec.id)
          .selects(Entity_Spec.name)
          .selects(Entity_Spec.color)
          .order(Entity_Spec.name, true)
          .filterAnd([Entity_Spec.entity, Entity_Spec.status].join('.')+'=?','active')
          .page(1).onPage(1000)
          .addStateCallback((v)=> this.loadState.setRequestBuilderState(v))
          .request((v)=>{
              this.items = v.items;
          }, (e)=>{
            console.error(e.response.data.message);
          })  
      } 
    }
  }
}
</script>